import { AfterViewInit, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface summariseObject {
    document_title: string;
    chapter: {
        title: string,
        content: string,
        important_insights: string
    }[]
    summary: string;
    // author: string;
    // title: string;
}

export enum ExtractionState {
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
    ERROR_TO_BIG = "ERROR_TO_BIG",
    WAITING = "WAITING",
    ERROR_TOO_MUCH_TEXT = "ERROR_TOO_MUCH_TEXT",
    ERROR_WRONG_TYPE = "ERROR_WRONG_TYPE"
}

export interface RRFile extends File {
    extractingState?: ExtractionState;
}

@Component({
    selector: 'app-user-rag',
    standalone: false,
    templateUrl: './user-rag.component.html',
    styleUrl: './user-rag.component.scss'
})
export class UserRagComponent implements AfterViewInit {
    dialog = inject(MatDialogRef<UserRagComponent>);
    data = inject(MAT_DIALOG_DATA);
    private destroyRef = inject(DestroyRef);

    extractedObject: string | undefined;
    backupData: any;

    ngAfterViewInit(): void {
        this.extractedObject = this.data || undefined;

        this.dialog.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    close() {
        this.dialog.close('closed');
    }

    useUploadContent(content: any) {
        this.dialog.close(content);
    }
}

